import styled from 'styled-components';

export const StatisticHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
`;

export const ProgressWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const StatsFramesWrapper = styled.div`
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(3, 1fr);
`;

export const ActionWrapper = styled.div`
    align-items: flex-end;
    display: flex;
    flex-grow: 1;
    margin-top: 24px;
`;
